import {useIsMobile} from '@legit.health/ui';
import {useCurrentPatient} from '@/patient/context/CurrentPatientContext';

export default function useCanUploadPhotos() {
  const patient = useCurrentPatient();
  const isMobile = useIsMobile();

  if (!patient.isAllowedToUploadPhotos) {
    return false;
  }

  if (patient.isMobileOnlyPhotoEnabled && !isMobile) {
    return false;
  }

  return true;
}
